import React from 'react';
import styles from './LabeledFormSectionContainer.module.scss';

const LabeledFormSectionContainer = ({ children, label }) => {
  return (
    <div className={styles.container}>
      <label>{label}</label>
      <div className={styles.interactiveArea}>
        {children}
      </div>
    </div>
  );
};

export default LabeledFormSectionContainer;
